import { render, staticRenderFns } from "./TaxableRebateGroupSetupEdit.vue?vue&type=template&id=044c6f3f"
import script from "./TaxableRebateGroupSetupEdit.vue?vue&type=script&lang=js"
export * from "./TaxableRebateGroupSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports